export function clamp(input, min, max) {
    return Math.max(Math.min(input, max), min);
}
export function roundToDecimal(value, decimals) {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
export function getDistance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
}
export function lerp(start, end, t) {
    return start + (end - start) * t;
}
